import { ajax } from '@/api/ajax'

//1、课堂表现分页查询
export const reqShowList = (paramets) => ajax(`/jxclassroom/jxClassroomActivity/list`, paramets)

//2、课堂表现根据id获取学生
export const reqShowStuById = (paramets) => ajax(`/jxclassroom/jxClassroomActivityStu/getActStuDetails`, paramets)

//3、课堂表现获取学生得分详情
export const reqShowStuDetail = (paramets) => ajax(`/jxclassroom/jxClassroomActivityStu/getActStuDetails`, paramets)

//4、课堂表现根据id删除
export const reqShowDelById = (paramets) => ajax(`/jxclassroom/jxClassroomActivity/delete`, paramets, 'delete')